import { ApiDatasource } from '../../adapters/io/datasources/ApiDatasource';
import { unwrap } from '../../adapters/io/network/HttpResponse';
import { formatText } from '../../adapters/io/network/utils';
import { ApiDatasourceSpec } from '../../core/datasource';
import { Order } from "../../../../graphics/tables/operations/sort";
import { SubActivityTableStructure} from "../indexes/SubActivityIndexes";
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';

export const searchSubActivity = <T>(
    authState: AuthState,
    search: SubActivityTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<SubActivityTableStructure.ResponseOf<T>> => {
    const params = new Map();
    const body = {
        fieldSearches : search
    }
    page !== undefined && params.set('page', page);
    limit !== undefined && params.set('limit', limit);
    order !== undefined && params.set('order', order);
    orderBy !== undefined && params.set('orderBy', orderBy);

    return datasource.remote
        .postData<SubActivityTableStructure.ResponseOf<T>, SubActivityTableStructure.ListOfFormattedSearchValue>(
            uriFormatter(EndpointSubActivity.endPoint.concat(EndpointSubActivity.searchSubActivities), {}),
            body, buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointSubActivity = {
    endPoint: '/end-point/sub-activity',
    searchSubActivities: ''
};